<div class="portal-map-area">
    <div [cdkPortalOutlet]="mapPortal"></div>
</div>
